<app-report-runner
  reportType="outcomes"
  title="Outcomes Report"
  description="Outcomes achieved during the selected period."
/>
